import { useSelector } from 'react-redux'
import { useNavigation } from '@react-navigation/native'
import { Feature, useFeatureFlag } from '@src/components/FeatureFlag'
import { EhrAppointmentKind } from '@src/types'
import {
  latestUserEhrAppointmentEarlierAvailableSlotsSelector,
  latestUserEhrAppointmentSelector,
} from '../models/nutritionistHub.selectors'

export const useEhrEarlierSlotAvailableAlert = () => {
  const navigation = useNavigation()

  const latestAppointment = useSelector(latestUserEhrAppointmentSelector)

  const earlierAvailableSlotsCheckFeatureEnabled = useFeatureFlag(
    Feature.VideoCallsEarlierAvailableSlotsCheck,
  )

  const earlierAvailableSlots = useSelector(latestUserEhrAppointmentEarlierAvailableSlotsSelector)

  const earlierSlotsAvailable = earlierAvailableSlots.length > 0

  const onPress = () => {
    if (!latestAppointment) {
      return
    }

    navigation.navigate('RescheduleVideoCallToEarlierSlot', {
      appointmentKind: latestAppointment.kind as EhrAppointmentKind,
      appointmentId: latestAppointment.id,
      nutritionistName: latestAppointment.providerName,
      title: latestAppointment.title,
      date: latestAppointment.meetingAt as string,
    })
  }

  return { showAlert: earlierAvailableSlotsCheckFeatureEnabled && earlierSlotsAvailable, onPress }
}
